import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class AdminService {
    constructor(private authService: AuthService) { }

    /**
     * Checks if the current user is an admin based on their email
     * @returns boolean indicating if the current user has admin privileges
     */
    isAdmin(): boolean {
        const currentUser = this.authService.getCurrentUser();
        if (!currentUser || !currentUser.email) {
            return false;
        }

        return environment.admins.includes(currentUser.email);
    }
}